import { progressBarCss, stepCss } from "./ProgressBar.style";

interface ProgressBarProps {
  current: number;
  count: number;
}

const getStepState = (
  questionNumber: number,
  current: number,
  count: number,
) => {
  if (questionNumber < current || current >= count) return "Complete";
  if (questionNumber === current) return "Current";
  return "In Progress";
};

const ProgressBar = ({ current, count }: ProgressBarProps) => {
  const numericCurrent = Math.min(current, count);

  return (
    <ul css={progressBarCss} aria-label="Quiz progress">
      {Array.from({ length: count }).map((_, index) => {
        const questionNumber = index + 1;
        const isStepComplete = index < numericCurrent;
        const state = getStepState(questionNumber, numericCurrent, count);
        return (
          <li
            key={`progress-bar-step-${index}`}
            css={stepCss(count, isStepComplete)}
            aria-label={`Question ${questionNumber} ${state}`}
          />
        );
      })}
    </ul>
  );
};

export default ProgressBar;
